import React from "react";
import CreateProperty from "./CreateProperty";

import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

const EditProperty = () => {
  const { projects } = useSelector((state) => state.projects);
  const { id } = useParams();

  return <CreateProperty {...{ property: projects.find((v) => v.id === +id) }} />;
};

export default EditProperty;
